import { IBeneficiary, IFirstCustomer } from '../model/firstCustomer.model';
import { ACTION_TYPES } from './store/firstCustomer.actions';

export const updateFirstCustomer = (customerData: Partial<IFirstCustomer>) => ({
  type: ACTION_TYPES.UPDATE_CUSTOMER,
  payload: customerData
});

export const resetFirstCustomer = () => ({
  type: ACTION_TYPES.RESET_CUSTOMER
});

// Ajouter un bénéficiaire
export const addBeneficiary = (beneficiary: IBeneficiary) => ({
  type: ACTION_TYPES.ADD_BENEFICIARY,
  payload: beneficiary
});

// Supprimer un bénéficiaire par index
export const removeBeneficiary = (index: number) => ({
  type: ACTION_TYPES.REMOVE_BENEFICIARY,
  payload: index
});

// Mettre à jour un bénéficiaire par index
export const updateBeneficiary = (index: number, updates: Partial<IBeneficiary>) => ({
  type: ACTION_TYPES.UPDATE_BENEFICIARY,
  payload: { index, updates }
});
